import { createSlice, createAction } from '@reduxjs/toolkit';
import { loginAdminThunk, loginByPhoneThunk, logoutAdmin } from '../thunks/authThunk';

const initialState = {
  token: null,
  refreshToken: null,
  tokenType: null,
  expiresIn: null,
  user: null,
  loading: false,
  error: null,
};

export const logoutAndResetStore = createAction("auth/logoutAndResetStore");

const authSlice = createSlice({
  name: 'authSlice',
  initialState,
  reducers: {
    logout(state) {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginAdminThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginAdminThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload.token;
        state.refreshToken = action.payload.refreshToken;
        state.tokenType = action.payload.tokenType;
        state.expiresIn = action.payload.expiresIn;
        state.user = action.payload.userBasicDetail;
      })
      .addCase(loginAdminThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Login failed';
      })
      .addCase(logoutAdmin.fulfilled, () => {
        return initialState; // clear everything on successful logout
      }).addCase(logoutAndResetStore, () => {
        return initialState;
      });
  },
});




const initialStatePhone = {
  userName: "",
  loading: false,
  error: null,
};

const loginByPhoneSice = createSlice({
  name: 'loginByPhoneSice',
  initialStatePhone,
  reducers: {
    logout(state) {
      return initialStatePhone;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginByPhoneThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginByPhoneThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.userName = action.payload;
      })
      .addCase(loginByPhoneThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Login failed';
      })
      .addCase(loginByPhoneThunk.fulfilled, () => {
        return initialStatePhone; // clear everything on successful logout
      }).addCase(logoutAndResetStore, () => {
        return initialStatePhone;
      });
  },
});


export const { byPhone } = loginByPhoneSice.actions;
export const { logout } = authSlice.actions;
export default authSlice.reducer;